<template>
    <b-form-group v-show="show">
        <div class="row">
            <div class="col-8">
                <strong>
                    Je perçois une retraite à titre personnel et j'ai cotisé au moins 15 ans (60 trimestres) à un ou plusieurs régimes obligatoires de sécurité sociale*<br />
                    <u>OU</u><br />
                    Je perçois une pension de réversion et mon conjoint a cotisé au moins 15 ans (60 trimestres) à un ou plusieurs régimes obligatoires de sécurité sociale*
                </strong>
            </div>
            <div class="col-4 d-flex justify-content-end align-self-center">
                <b-form-radio-group
                    id="radio-quinze-annees-cotisation"
                    v-model="quinzeAnneesCotisations"
                    :options="listeQuinzeAnneesCotisations"
                    name="quinze-annees-cotisation"
                ></b-form-radio-group>
            </div>
        </div>

        <b-alert show v-if="quinzeAnneesCotisations == 0" variant="danger" class="mt-3 mb-0">
            <b-row align-v="center">
                <b-col cols="auto">
                    <b-icon icon="x-circle" scale="1.5"></b-icon>
                </b-col>
                <b-col>
                    Vous ne disposez pas de la durée de cotisation minimale requise pour bénéficier d'une affiliation au CNAREFE.
                </b-col>
            </b-row>
        </b-alert>

    </b-form-group>
</template>

<script>
export default {
  name: 'QuinzeAnneesCotisations',
  props: [
      'show'
  ],
  data() {
      return {
        listeQuinzeAnneesCotisations: [
            { text: 'Oui', value: 1 },
            { text: 'Non', value: 0 }
        ]
      }
  },
  computed: {
    quinzeAnneesCotisations: {
        get() {
            return this.$store.quinzeAnneesCotisations
        },
        set(val) {
            this.$store.quinzeAnneesCotisations = val
        }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/QuinzeAnneesCotisations.vue